/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import Star from './Star';

import './StarRating.scss';

interface StarRatingProps {
    rating: number;
    maximumNumberOfStars?: number;
}

const StarRating: FunctionComponent<StarRatingProps> = ({ rating, maximumNumberOfStars = 4 }) => {
    const fillArray: number[] = [];
    let mutableRating = rating;

    for (let i = 0; i < maximumNumberOfStars; i += 1) {
        if (mutableRating >= 1) {
            fillArray.push(1);
            mutableRating -= 1;
        } else if (mutableRating < 1 && mutableRating > 0) {
            fillArray.push(mutableRating);
            mutableRating = 0;
        } else {
            fillArray.push(0);
        }
    }

    return (
        <div className="star-rating-container">
            {fillArray.map((fill, index) => (
                <Star key={index} fill={fill} />
            ))}
        </div>
    );
};

export default StarRating;
